<template>
  <div class="bill-action-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false">
       <el-form ref="params" :model="params" label-width="200px" :rules="rules" style="paddingRight: 140px">
        <el-form-item label="商户id:" v-if="title === '编辑聚商'" prop="uid">
          <el-input size="small" placeholder="请输入商户id" v-model="params.uid" disabled></el-input>
        </el-form-item>
        <el-form-item label="账户名:" prop="name">
          <el-input size="small" placeholder="请输入账户名" v-model="params.name"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-if="type !=='edit'" prop="password">
           <el-input size="small" placeholder="请输入密码" v-model="params.password"></el-input>
        </el-form-item>
        <el-form-item v-if="type ==='edit'" label="密码:"  >
              <el-button @click="handleModifyPassword" v-if="!isModify" type="info"  size="mini" >修改密码</el-button>
              <el-input v-else  size="small"  placeholder="请输入密码" v-model="password">
                <template slot="append">
                  <el-button size="small" plain="" @click="handleModifyPassword">取消修改</el-button>
                </template>
              </el-input>
        </el-form-item>
        <el-form-item label="昵称:" prop="nickname">
          <el-input size="small" placeholder="请输入昵称" v-model="params.nickname"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input size="small" placeholder="请输入邮箱" v-model="params.email"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="mobile">
          <el-input size="small" placeholder="请输入手机号" v-model="params.mobile"></el-input>
        </el-form-item>
        <el-form-item label="商人所属聚商ID:" prop="cid" v-if="type ==='edit'">
          <el-input size="small" placeholder="请输入商人所属聚商ID" v-model="params.cid" disabled ></el-input>
        </el-form-item>
        <el-form-item label="商人余额:" prop="balance" v-if="this.title === '新增聚商'">
          <el-input size="small" placeholder="请输入商人余额" v-model="params.balance" ></el-input>
        </el-form-item>
        <el-form-item label="是否禁止登录:" prop="hasLocked" placeholder="是否禁止登陆">
          <el-select v-model.number="params.hasLocked"> 
            <el-option label="是" :value='true'></el-option>
            <el-option label="否" :value='false'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('params')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
import { validatorIndex } from '@/utils/validator'
export default {
  data() {
    return {
      title: '',
      password:'',
      type:'',//弹出框类型
      isModify:false, //不显示修改密码
      dialogVisible: false,
      flag: false,
      id: '',
      // 新增/编辑参数
      params: {
      uid:undefined ,
      name:undefined ,
      password:undefined ,
      email:undefined ,
      mobile:undefined ,
      cid:undefined ,
      channel:undefined ,
      wechat:undefined ,
      balance:undefined ,
      qq:undefined,
      hasLocked:undefined,
      },
      // 表单验证规则
      rules: {
        uid: [
          { required: true, message: '必填', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '必填', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '必填', trigger: 'blur' },
        ],
        nickname: [
          { required: true, message: '必填', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '必填', trigger: 'change' }
        ],
        mobile: [
          { required: true, message: '必填', trigger: 'blur' },
          { validator: this.validatorMobile, trigger: 'blur' }
        ],
        cid: [
          { required: true, message: '必填', trigger: 'blur' },
        ],
        channel: [
          { required: true, message: '必填', trigger: 'blur' },
        ],
        wechat: [
          { required: true, message: '必填', trigger: 'blur' },
        ],
        balance: [
          { required: true, message: '必填', trigger: 'blur', },
          { validator: validatorIndex, trigger: 'blur' }
        ],
        hasLocked: [
          { required: true, message: '必选', trigger: 'change' },
        ]
      }
    }
  },
  methods: {
    // 关闭弹窗时
    handleClose() {

      this.dialogVisible = false
      this.flag = false
      this.params = {
        uid:undefined ,
        name:undefined ,
        password:undefined ,
        email:undefined ,
        mobile:undefined ,
        cid:undefined ,
        channel:undefined ,
        wechat:undefined ,
        balance:undefined ,
        qq:undefined,
        hasLocked:undefined,
      }
      // eslint-disable-next-line no-console
      console.log(this.$refs['params'])
      this.$refs['params'].resetFields()
    },
    // 手机号码验证
    validatorMobile(rule, value, callback) {
      if(!value) {
        return callback(new Error('必填'))
      }else {
        let reg = /^1[3456789]\d{9}$/
        if(reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    },
    // 表单验证提交
    submitForm() {
      this.$refs.params.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '编辑聚商') {
            if(this.isModify){
              this.params.password = this.password
            }else {
              this.params.password = undefined
            }
            this.editGatheringList()
          } else{
            this.addGatheringList()
          }
        } else {
          return false;
        }
      });
    },
    // 新增聚商
    addGatheringList(){
      this.params.balance = parseFloat(this.params.balance)
       API.addGatheringList(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增商人成功',
            type: 'success'
          });
          this.$emit('handlerBillList')
        }  else {
          this.$message.error('新增商人失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 修改密码
    handleModifyPassword(){
      this.password = '111'
      this.isModify = !this.isModify
      if(this.isModify){
        this.password = undefined
      }
    },
      // 编辑聚商
    editGatheringList() {
      this.params.balance = parseFloat(this.params.balance)
      API.editGatheringList(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑商人成功',
            type: 'success'
          });
          this.$emit('handlerBillList')
        }  else {
          this.$message.error('编辑商人失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    open(type, row) {
        this.dialogVisible = true
        this.type = type
        if (type === 'edit') {
          this.title = '编辑聚商'
          this.params = {...row,...{}}
        }else {
        this.title = '新增聚商'
        }
      }
  }
}
</script>